<p-confirmdialog />
<p-toast />
<p-dialog
  header="Change Price"
  (onShow)="dialogShown()"
  (onHide)="dialogClosed()"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '25rem' }"
>
  <p-blockui [blocked]="isLoading" />
  <div class="surface-ground px-4 py-8 md:px-6 lg:px-8">
    <div class="text-900 font-medium text-xl mb-3">Change Price</div>
    <div class="surface-card p-4 shadow-2 border-round p-fluid">
      <div class="grid formgrid p-fluid">
        <div class="field mb-4 col-6 md:col-3">
          <label for="item" class="font-medium text-900">Customer Name</label>
          <div class="flex align-content-center"></div>
          <span class="p-text-secondary block mb-8">{{customerName}}</span>
        </div>
        <div class="field mb-4 col-6 md:col-3">
          <label for="item" class="font-medium text-900">Plan Name</label>
          <div class="flex align-content-center"></div>
          <span class="p-text-secondary block mb-8"
            >{{planName}}</span
          >
        </div>
        <div class="field mb-4 col-6 md:col-3">
          <label for="item" class="font-medium text-900">Plan Price</label>
          <div class="flex align-content-center"></div>
          <span class="p-text-secondary block mb-8"
            >{{planPrice | currency: 'USD'}}</span
          >
        </div>
        <div class="field mb-4 col-6 md:col-3">
          <label for="item" class="font-medium text-900">Current Price</label>
          <div class="flex align-content-center"></div>
          <span class="p-text-secondary block mb-8"
            >{{currentPrice | currency: 'USD'}}</span
          >
        </div>
        <div class="field mb-4 col-6 md:col-3">
          <label for="item" class="font-medium text-900">New Price</label>
          <div class="flex align-content-center">
            <p-inputNumber
              mode="currency"
              [(ngModel)]="newPrice"
              currency="USD"
              inputId="item"
              type="text"
              class="flex-1"
            ></p-inputNumber>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <p-button
      label="Cancel"
      [text]="true"
      severity="secondary"
      (click)="visible.set(false)"
    />
    <p-button
      label="Change Price"
      [disabled]="currentPrice === newPrice"
      [outlined]="true"
      severity="primary"
      (click)="changePrice()"
    />
  </ng-template>
</p-dialog>
